import { defineMessages } from 'react-intl'

export default defineMessages({
  defaultError: {
    id: 'requests.errors.defaultError',
    defaultMessage: 'Unknown error',
  },
  permissionDenied: {
    id: 'requests.errors.permissionDenied',
    defaultMessage: 'Permission denied',
  },
})
